export function useNavigationEpoch() {
  return useState<number>('blog-navigation-epoch', () => 0)
}

export function useNavigationStaleGuard() {
  const epoch = useNavigationEpoch()
  const entryEpoch = epoch.value
  const isStaleNavigation = () => import.meta.client && epoch.value !== entryEpoch

  return {
    isStaleNavigation
  }
}

export function isAbortLikeError(error: unknown) {
  const target = error as {
    name?: string
    message?: string
    cause?: { name?: string; message?: string } | null
  } | null
  const name = String(target?.name || target?.cause?.name || '').toLowerCase()
  const message = String(target?.message || target?.cause?.message || '').toLowerCase()
  return name === 'aborterror' || message.includes('aborted') || message.includes('abort')
}
